import {enableProdMode} from "@angular/core";
import {environment} from "../environment/environment";
import {AppVersion} from "../app-version";
import * as Sentry from "@sentry/angular";

export function initSentry(): void {
  console.log('Sentry init');
  Sentry.init({
    dsn: environment.sentryDNS  || '',
    environment: environment.name,
    release: AppVersion,
    tracesSampleRate: environment.production ? 0.05 : 1.0,
    replaysSessionSampleRate:  environment.production ? 0 : 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: ['localhost', 'collegial-stats-fe-3zn3l.ondigitalocean.app'],
    integrations: [Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    })],
  });

  Sentry.withScope((scope: any) => {
    scope.setLevel('warning');
  });

  enableProdMode();
}

console.log('Sentry init - done');
export {Sentry};

type SentryTags = Record<string, string | number | undefined | null>;
type SentryExtra = {tags?: SentryTags, context?: {key: string, data: Record<string, unknown>}};

function withTags({tags = {}, context}: SentryExtra, capture: () => void): void {
  Sentry.withScope((scope: any) => {
    Object.entries(tags).forEach(([key, value]) => {
      if (value !== undefined && value !== null) scope.setTag(key, String(value));
    });
    if (context) scope.setContext(context.key, context.data);
    capture();
  });
}

// À utiliser à la place de Sentry.captureException/captureMessage bruts dès qu'un gameId/gamePlayNumber
// est disponible : les tags sont indexés par Sentry (filtrables dans le dashboard), contrairement à
// setContext(). withScope() borne aussi tags/contexte à cette capture précise, pour éviter qu'ils
// restent collés au scope global et ne fuitent sur un événement suivant sans rapport.
export function captureExceptionWithTags(error: unknown, tags: SentryTags = {}, context?: SentryExtra['context']): void {
  withTags({tags, context}, () => Sentry.captureException(error));
}

export function captureMessageWithTags(message: string, tags: SentryTags = {}, context?: SentryExtra['context']): void {
  withTags({tags, context}, () => Sentry.captureMessage(message));
}
